<div class="terms-container">
  <!-- Loader -->
  <div *ngIf="isLoading" class="loading-section">
    <div class="loading-content">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'Loading terms and conditions...' | translate }}</p>
    </div>
  </div>

  <!-- Terms Content -->
  <div *ngIf="!isLoading && hasTermsToAccept" class="terms-content">
    <!-- Header -->
    <div class="header">
      <h1 class="title">
        <mat-icon>description</mat-icon> {{ 'Terms and Conditions Update for Divinea.com' | translate }}
      </h1>
    </div>

    <!-- Body -->
    <div class="content-body">
      <!-- Warning Banner -->
      <div class="warning-banner">
        <mat-icon class="warning-icon">info</mat-icon>
        <p class="warning-text">
          {{ 'Dear Customer, we have made changes to our terms and conditions. To continue using Wine Suite, you must accept the following clauses.' | translate }}
        </p>
      </div>

      <!-- Agreements Loop -->
      <div *ngFor="let agreement of agreementsInfo" class="terms-section">
        <!-- Full Text -->
        <div class="terms-full-text" [innerHTML]="agreement.fullText"></div>

        <!-- Links Doc -->
        <div *ngIf="agreement.linksDoc" class="view-all-terms">
          <mat-icon>description</mat-icon>
          <a [href]="agreement.linksDoc" target="_blank" rel="noopener">
            {{ 'Review the complete Terms and Conditions documentation' | translate }}
          </a>
        </div>

        <!-- Remaining Days -->
        <div *ngIf="agreement.remainingDaysToAccept" class="time-remaining">
          <mat-icon>schedule</mat-icon>
          <p class="time-text">
            {{ 'Time remaining for acceptance:' | translate }}
            <span class="time-days">
              {{ agreement.remainingDaysToAccept }} {{ agreement.remainingDaysToAccept === 1 ? ('day' | translate) : ('days' | translate) }}
            </span>
          </p>
        </div>
        <div *ngIf="agreement.remainingDaysToAccept === 0 && !agreement.mustAccept" class="time-remaining">
          <mat-icon>schedule</mat-icon>
          <p class="time-text">
            <span class="time-days">
              {{ 'Last day to accept' | translate }}
            </span>
          </p>
        </div>

        <div class="agreement-checkbox">
          <!-- Checkbox for WineSuite Updates -->
          <div *ngIf="agreement.acceptWineSuiteUpdates" (click)="toggleAgreement(agreement.id, 'acceptWineSuiteUpdates')">
            <ws-checkbox
              [checked]="getAcceptance(agreement.id)?.acceptWineSuiteUpdates">
              <label class="checkbox-label" right>
                {{ 'I accept the updated general Terms and Conditions' | translate }}
                <span *ngIf="agreement.mustAccept" class="required-asterisk">*</span>
              </label>
            </ws-checkbox>
          </div>

          <!-- Checkbox for Exclusive Offers -->
          <div *ngIf="agreement.acceptExclusive" (click)="toggleAgreement(agreement.id, 'acceptExclusive')">
            <ws-checkbox
              [checked]="getAcceptance(agreement.id)?.acceptExclusive">
              <label class="checkbox-label" right>
                {{ 'I expressly accept the onerous clauses' | translate }}
                <span *ngIf="agreement.mustAccept" class="required-asterisk">*</span>
              </label>
            </ws-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="actions-section">
      <ws-button *ngIf="!hasMustAcceptTerms"
        callToActionType="tertiary"
        class="close-btn"
        [disabled]="isSubmitting"
        (click)="submitAcceptance(false)">
        {{ 'Close temporarily' | translate }}
      </ws-button>

      <ws-button
        callToActionType="primary"
        class="accept-btn"
        [disabled]="!canSubmit || isSubmitting"
        (click)="submitAcceptance(true)">
        <span *ngIf="isSubmitting" class="button-spinner"></span>
        <span>
          {{
            isSubmitting
              ? ('Processing...' | translate)
              : ('Accept and continue' | translate)
          }}
        </span>
      </ws-button>
    </div>

    <p class="required-note" *ngIf="hasMustAcceptTerms">
      <span class="required-asterisk">*</span>
      {{ 'Required fields' | translate }}
    </p>
  </div>
</div>
